module.exports = __webpack_public_path__ + "assets/img/companyicon9.3dabff5d.jpg";